import React, {useState} from 'react';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import Copying from 'shared/ui/icons/Copying';
import ArrowForSelect from 'shared/ui/icons/ArrowForSelect';
import {useCopyToClipboard} from 'shared/lib/hooks/useCopyToClipboard';

import {WEBHOOK_PAYLOAD_EXAMPLE_GEO} from '../webhookPayloadExample';

import styles from './WebhookPayloadHint.module.scss';

const WebhookPayloadHint: React.FC = () => {
    const {copy} = useCopyToClipboard();
    const [isOpen, setIsOpen] = useState(false);

    const payload = WEBHOOK_PAYLOAD_EXAMPLE_GEO;

    return (
        <div className={styles.payloadBlock}>
            <div className={styles.payloadHead}>
                <button
                    className={styles.payloadToggle}
                    onClick={() => setIsOpen(prev => !prev)}
                    aria-expanded={isOpen}
                    type="button"
                >
                    <span className={cn(styles.payloadChevron, isOpen && styles.payloadChevronOpen)}>
                        <ArrowForSelect />
                    </span>
                    <span className={styles.payloadTitle}>
                        {t`Формат запроса, который придёт на ваш URL при открытии и разрешении инцидента`}
                    </span>
                </button>
                {
                    isOpen && (
                        <button
                            className={styles.copyButton}
                            onClick={() => copy(payload)}
                            aria-label={t`Скопировать пример payload`}
                            type="button"
                        >
                            <Copying />
                            {t`Копировать`}
                        </button>
                    )
                }
            </div>
            {
                isOpen && <pre className={styles.payloadCode}>{payload}</pre>
            }
        </div>
    );
};

export default WebhookPayloadHint;
